import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const faqs = [
  {
    question: 'Comment choisir le meilleur site de paris en ligne en France ?',
    answer: 'Plusieurs critères déterminent la qualité d\'un site de paris : la licence ANJ obligatoire, la rapidité des retraits, la variété des sports et marchés disponibles, la qualité des cotes, les promotions régulières, et surtout la réputation auprès des parieurs. Nous testons chacun de ces éléments pour vous guider vers les opérateurs les plus performants.',
  },
  {
    question: 'Les bonus de bienvenue sont-ils vraiment avantageux ?',
    answer: 'Oui, lorsqu\'ils sont bien utilisés. Un bonus de 100€ peut doubler votre bankroll initial, mais attention aux conditions de mise (wager) qui déterminent combien de fois vous devez miser le montant avant de pouvoir retirer. Les meilleurs bonus offrent des conditions raisonnables (entre x3 et x5) et s\'appliquent sur des paris réels, pas des mises gratuites avec restrictions.',
  },
  {
    question: 'Combien de temps faut-il pour retirer ses gains ?',
    answer: 'Les retraits varient selon les sites et les méthodes choisies. Les portefeuilles électroniques (PayPal, Skrill) sont généralement les plus rapides (24-48h), suivis des virements bancaires (2-5 jours). Les retraits par carte bancaire peuvent prendre jusqu\'à 7 jours. Nous indiquons ces informations pour chaque site que nous recommandons.',
  },
  {
    question: 'Puis-je avoir plusieurs comptes sur différents sites de paris ?',
    answer: 'Oui, vous pouvez avoir un compte sur chaque site de paris agréé en France. Cependant, vous ne pouvez pas créer plusieurs comptes sur le même site (cela viole les conditions générales). Avoir plusieurs comptes vous permet de comparer les cotes et de profiter de différentes promotions.',
  },
  {
    question: 'Comment fonctionne le cash out ?',
    answer: 'Le cash out vous permet de clôturer un pari avant la fin de l\'événement, soit pour sécuriser des gains partiels, soit pour limiter les pertes si la situation évolue défavorablement. Le montant proposé évolue en temps réel selon la probabilité de gain. C\'est un outil stratégique puissant pour gérer vos paris en direct.',
  },
  {
    question: 'Les sites que vous recommandez sont-ils sécurisés ?',
    answer: 'Absolument. Nous ne recommandons que des sites titulaires d\'une licence ANJ valide, ce qui garantit leur conformité aux réglementations françaises strictes en matière de sécurité, de protection des données et de jeu responsable. Tous les sites sont audités régulièrement et doivent respecter des standards élevés de protection des joueurs.',
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  return (
    <section id="faq" className="py-20 bg-gradient-to-b from-gray-800 to-gray-900">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Questions Fréquentes
            </h2>
            <p className="text-xl text-gray-400">
              Les réponses aux questions que vous vous posez le plus souvent
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-gray-800 rounded-xl border border-gray-700 overflow-hidden transition-all"
              >
                <button
                  className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-gray-700/50 transition-colors"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <span className="text-white font-semibold pr-4">{faq.question}</span>
                  {openIndex === index ? (
                    <ChevronUp className="text-pink-400 flex-shrink-0" size={20} />
                  ) : (
                    <ChevronDown className="text-pink-400 flex-shrink-0" size={20} />
                  )}
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-5">
                    <p className="text-gray-300 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;

